import {
  useBikeleasingPortalLinkBuilder as useSharedBikeleasingPortalLinkBuilder,
  withPreselectedRole as withSharedPreselectedRole,
} from 'probonio-shared-ui/utils/bikeleasingUrl';
import { BIKELEASING_PRESELECTED_ROLE } from '../../constants';

export function useBikeleasingPortalLinkBuilder(): (path?: string) => string {
  return useSharedBikeleasingPortalLinkBuilder(BIKELEASING_PRESELECTED_ROLE);
}

export function withPreselectedRole(url: string): string {
  return withSharedPreselectedRole(url, BIKELEASING_PRESELECTED_ROLE);
}
